import style from '../../../styles/Weather/weather_current_conditions'

const Row = ({ title, data, unit }) => (
  <div className='row'>
    <span>{title}</span>
    <span className='data'>{data + unit}</span>
    <style jsx>{style}</style>
  </div>
)

const Bottom = ({ forecast }) => {
  const {
    temperatureFeelsLike = '',
    relativeHumidity = '',
    windDirectionCardinal = '',
    windSpeed = ''
  } = forecast || {}

  const data = [
    {
      title: 'Feels like',
      data: temperatureFeelsLike,
      unit: '°'
    },
    {
      title: 'Humidity',
      data: relativeHumidity,
      unit: '%'
    },
    {
      title: 'Wind',
      data: windSpeed && `${windDirectionCardinal} ${windSpeed}`,
      unit: 'mph'
    }
  ]

  return (
    <div className='container-bottom'>
      {data.map((el, index) => el.data && <Row key={index} data={el.data} title={el.title} unit={el.unit} />)}
      <style jsx>{style}</style>
    </div>
  )
}

export default Bottom
